export interface IUserEdge {
  node: IUser;
}

export interface IUser {
  id: number;
  username: string;
  mobile: string;
  email: string;
  firstName?: string;
  lastName: string;
  street?: string;
  unit?: string;
  postal?: string;
  birthDate?: Date;
  source?: string;
  joinDate: Date;
  points: number;
}

export interface IUpdateUserInput {
  mobile?: string;
  email?: string;
  firstName?: string;
  lastName: string;
  street?: string;
  unit?: string;
  postal?: string;
  birthDate?: Date;
  source?: string;
}

export const publicUserGQL: Record<string, string> = {
  logIn: `
    mutation LogIn($username: String!, $password: String!) {
      logIn: logIn(audience: "m", username: $username, password: $password) {
        accessToken
        tokenType
        expiresIn
      }
    }
  `,
  resetPassword: `
    mutation ResetPassword($code: String!, $password: String!) {
      resetPassword: resetPassword(code: $code, password: $password)
    }
  `,
  sendResetPasswordEmail: `
    mutation SendResetPasswordEmail($username: String!, $email: String!) {
      sendResetPasswordEmail: sendResetPasswordEmail(audience: "m", username: $username, email: $email)
    }
  `,
};

export const authenticatedUserGQL: Record<string, string> = {
  logOut: `
    mutation LogOut() {
      logOut
    }
  `,
  me: `
    query Me {
      me: me {
        node {
          id
          username
          mobile
          email
          firstName
          lastName
          street
          unit
          postal
          birthDate
          source
          joinDate
          points
        }
      }
    }
  `,
  updateMe: `mutation UpdateMe($input: UpdateMemberInput!) {
    updateMe: updateMe(input: $input) {
      node {
        id
        username
        mobile
        email
        firstName
        lastName
        street
        unit
        postal
        birthDate
        source
        joinDate
        points
      }
    }
  }`,
};
